import { Router } from '@angular/router';
import { fuseAnimations } from './../../../../@fuse/animations/index';
import { NotificationService } from './../../../main/pages/accompaniments/notification.service';
import { ChangeDetectorRef, Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { ToolbarComponent } from '../toolbar/toolbar.component';
import { forkJoin } from 'rxjs';
import { Notification } from 'app/entities/notification';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

@Component({
    selector: 'quick-panel',
    templateUrl: './quick-panel.component.html',
    styleUrls: ['./quick-panel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class QuickPanelComponent {
    notifications: Notification[] = [];
    unreadNotifications: Notification[] = [];

    @ViewChild(ToolbarComponent) toolbarComponent: ToolbarComponent;

    constructor(
        private _notificationService: NotificationService,
        private _fuseSidebarService: FuseSidebarService,
        private _router: Router,
        private cd: ChangeDetectorRef,
    ) {
        this._notificationService.findAll({}).subscribe(res => {
            this.notifications = res.data
            this.filterUnread();
        })

        this._router.routeReuseStrategy.shouldReuseRoute = () => false;
        this._router.onSameUrlNavigation = 'reload';
    }

    ngOnInit() {
        this.load();

        this._notificationService.reload$.subscribe(() => {
            this.load();
        });
    }

    load() {
        this._notificationService.findAll({}).subscribe(res => {
            this.notifications = res.data
            this.filterUnread();
        });
    }

    async navigateToNotifiable(notification: any) {
        let notifiableType: string = notification.notifiableType;
        let route: string;
        let queryParams: { [key: string]: any };

        const className = notifiableType.split('\\').pop()?.toLowerCase() || '';

        switch (className) {
            case 'call':
                route = `accompaniments/${notification.notifiable.accompaniment_id}`;
                queryParams = { selectedIndex: 2 };
                break;
            case 'criticalanalysislink':
                route = `planos-producao/${notification.notifiable.cliente_id}`;
                queryParams = { selectedIndex: 1 };
                break;
            case 'cliente':
                route = `planos-producao/${notification.notifiable.id}`;
                queryParams = { selectedIndex: 1 };
                break;
            case 'contract':
                route = `clientes/${notification.notifiable.cliente_id}`;
                queryParams = { selectedIndex: 1 };
                break;
            default:
                console.error(`Unknown notifiable type: ${notifiableType}`);
                return;
        }

        this._fuseSidebarService.getSidebar('quickPanel').close();
        this._router.navigate([route], {
            replaceUrl: true,
            queryParams: queryParams
        });
    }

    markAsRead(notification: any, event: MouseEvent): void {
        event.stopPropagation();

        if (notification.read_at) return;

        this._notificationService.markAsRead(notification.id).subscribe({
            next: () => {
                notification.read_at = new Date();
                this.filterUnread();
                this.cd.detectChanges();
                this.ngOnInit();
                this._notificationService.notifyNotificationCountUpdated();
            },
            error: err => console.error('Erro ao marcar como lida', err)
        });
    }

    markAllAsRead(): void {
        const unreadNotifications = this.unreadNotifications;

        const markAll$ = unreadNotifications.map(notification => this._notificationService.markAsRead(notification.id));

        forkJoin(markAll$).subscribe({
            next: () => {
                this.notifications.forEach(notification => notification.readAt = new Date());
                this.filterUnread();
                this.cd.detectChanges();
                this._notificationService.notifyNotificationCountUpdated();
            },
            error: err => console.error('Erro ao marcar todas como lidas', err)
        });
        this.ngOnInit();
        this._notificationService.notifyNotificationCountUpdated();
    }

    filterUnread() {
        this.unreadNotifications = this.notifications?.filter(c => {
            const d = c.readAt;
            return !(d instanceof Date) || isNaN(d.getTime());
        });
    }
}
